import {Cureus} from '../Cureus';

Cureus.PosterUploader = {};

//= require_tree ./PosterUploader
